var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"cover-image w-100 m-0"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.alt}}),_c('figcaption',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }